
// import { generateToken04 } from '@/components/zego/server/zegoServerAssistant';
const { generateToken04 } = require('./server/zegoServerAssistant');
import {ZegoExpressEngine} from 'zego-express-engine-webrtc';

// 请将 appID 修改为你的 appId，appid 为 数字
// type: number
const appID = 1977187171;
// type: 32 byte length string
const serverSecret = '8c4f29a5d4d7576bd21e7380cbc29bcc';
const server = 'wss://webliveroom1977187171-api.imzego.com/ws';

export function initZeGoEngine(){
    // 初始化实例
    const zg = new ZegoExpressEngine(appID,server);
    zg.setDebugVerbose(false)
    zg.setLogConfig({
        logLevel:'disable'
    })
    return zg;
}


/**
 * 基础鉴权 token
 * @returns {Object}
 * @param userId
 */
export function getZeGoBasicToken(userId) {
    const effectiveTimeInSeconds = 3600; //type: number; unit: s； token 过期时间，单位：秒
//生成基础鉴权 token时，payload 要设为空字符串
    const payload = '';
// Build token
    const token =  generateToken04(appID, userId, serverSecret, effectiveTimeInSeconds, payload);
    // console.log('token:',token);
    return token;
}

/**
 * 权限认证 token 生成示例，使用前需联系即构技术支持开通功能
 * @param {string} url
 * @returns {Object}
 */
export function getZeGoAuthToken(userId,roomId) {
    const effectiveTimeInSeconds = 3600; //type: number; unit: s； token 过期时间，单位：秒
    const payloadObject = {
        room_id: roomId, // 请修改为用户的 roomID
        // 本示例生成的 token 允许 loginRoom（登录房间）
        // 本示例生成的 token 不允许 publishStream（推流）
        privilege: {
            1: 1,   // loginRoom: 1 pass , 0 not pass
            2: 0    // publishStream: 1 pass , 0 not pass
        },
        stream_id_list: null
    }; //
    const payload = JSON.stringify(payloadObject);
    // Build token
    const token =  generateToken04(appID, userId, serverSecret, effectiveTimeInSeconds, payload);
    // console.log('token:',token);
    return token;
}